import React, { FC, ReactNode, useContext } from "react";
import { useReactiveVar } from "@apollo/client";
import { Navigate, useParams } from "react-router-dom";
import { currentBranchIdVar } from "@me-team/host/main/globalVar/state";
import { AccessContext } from "@me-team/host/src/components/App/App";
import AccessService from "@me-team/host/services/AccessService";

interface ProtectedOwnerRouteProps {
    children: ReactNode;
}

const ProtectedOwnerRoute: FC<ProtectedOwnerRouteProps> = ({ children }) => {
    const { isReady } = useContext(AccessContext);
    const currentBranchId = useReactiveVar(currentBranchIdVar);
    const { branchId: routeBranchId } = useParams();

    if (isReady && AccessService.getInstance().hasRole && +currentBranchId === +routeBranchId) {
        return <Navigate to={`/branches/main/branch/${currentBranchId}`} replace />;
    }

    return children;
};

export default ProtectedOwnerRoute;
